import { render } from "./CustomerNotice.vue?vue&type=template&id=129c3a6c&scoped=true"
import script from "./CustomerNotice.vue?vue&type=script&lang=js"
export * from "./CustomerNotice.vue?vue&type=script&lang=js"

import "./CustomerNotice.vue?vue&type=style&index=0&id=129c3a6c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129c3a6c"]])

export default __exports__